import React from 'react'

const PrivacyPolicyPage = () => {
  return (
    <div className={` w-full relative py-[1rem] xl:py-6`}>
      <div className="w-full flex justify-center">
        <div
          style={{ maxWidth: '1056px', lineHeight: '1.875rem' }}
          className={`custom-page px-[5%] xl:px-0`}
        >
          <div style={{ color: 'white' }} className="custom-page-terms">
            <div>
              <h2>
                <strong>LUMICKO</strong>
              </h2>
              <h2>
                <strong>PRIVACY NOTICE</strong>
              </h2>
              <br />
              <p>
                <strong>1. </strong>
                <strong>WHAT IS OUR PRIVACY COMMITMENT</strong>
                <strong> </strong>
                <strong>?</strong>
              </p>
              <p>
                {` This Privacy Notice sets out how LUMICKO (a wholly owned subsidiary of the School of
                Media and Communication of Taylor's University and a part of the Taylor's Education
                Group), collects, uses, discloses, retains and protects your sensitive information
                including personally identifiable data (collectively, “Personal Data”) in accordance
                with the Personal Data Protection Act 2010 (“PDPA”), its amendment, subsidiary
                legislation and other applicable laws of Malaysia.`}
              </p>
              <br />
              <p>
                In order for us to process your Personal Data, your consent is required. In most
                cases, the processing of your Personal Data is necessary for us to provide you with
                the products and/or services you have requested. By voluntarily providing your
                Personal Data to us and/or continuing to access or use any of our websites, mobile
                applications and/or online platforms (collectively “our Sites”) or our products
                and/or services, you declare that you have read and understood this Privacy Notice
                and agree to us processing and use your Personal Data in accordance with the manner
                as set out in this Privacy Notice. However, if you choose not to provide any
                Personal Data, you may not be able to access or use certain features of our Sites,
                products and/or services.
              </p>
              <p>
                All words and phrases used in this Privacy Notice shall have the same meaning given
                to them in our Terms of Use. Specifically, the word “Authorised Third Party” shall
                mean contractors, agents and/or third-party suppliers engaged by us from time to
                time for the purposes of providing certain products and/or services.
              </p>
              <br />
              <p>
                <strong>2. </strong>
                <strong>WHAT TYPE OF INFORMATION DO WE COLLECT ?</strong>
              </p>
              <p>
                The information that we may collect about you will vary depending on how you
                interact and engage with us. For example, it may include:
              </p>
              <p>a. Personal Data that you provide to us</p>
              <ul className="list-disc">
                <li>
                  We collect Personal Data such as name, birthdate, identification supporting
                  documents (including NRIC or passport number), gender, nationality and race,
                  postal address, telephone number, facsimile number, email address, credit/debit
                  card information, photos etc. when you voluntarily provide such information to us
                  as and when required or when you register to our Sites or subscribe to our certain
                  products and/or services.
                </li>
              </ul>

              <p>b. Information we get from your use of our Sites</p>
              <ul className="list-disc">
                <li>
                  When you interact with us through the Sites, we may collect or receive and store
                  certain personally non-identifiable information. Such information is collected
                  passively using various technologies and cannot presently be used to specifically
                  identify you. This information includes:
                  <ol type="i">
                    <li>
                      device-specific information, including but not limited to operating system
                      version, unique device identifiers, mobile network information, memory, sound
                      card data, and IP address.
                    </li>
                    <li>cookies that may uniquely identify your browser.</li>
                    <li>details of how you use our Sites, such as your search queries.</li>
                    <li>
                      total number of visitors using our Sites, and the number of visitors to each
                      page of our Sites.
                    </li>
                    <li>how our users/customers use and interact with our Sites.</li>
                  </ol>
                </li>
              </ul>

              <br />
              <p>
                <strong>3. </strong>
                <strong>{`WHY WE COLLECT THIS INFORMATION AND WHERE IT'S USED`}</strong>
              </p>
              <p>
                We use the Personal Data and other information provided to us in a manner that is
                consistent with this Privacy Notice. Your Personal Data may be used and processed by
                us for the following purposes (collectively &quot;Purposes&quot;):
              </p>
              <p>a. Provision and Management of Sites</p>
              <ol type="i">
                <li>
                  To assess your application for subscription to our products and/or services.
                </li>
                <li>To assess your application to register for the use of our Sites.</li>
                <li>
                  To operate, administer and improve the delivery of our products and/or services.
                </li>
                <li>To verify and process payments and transactions.</li>
                <li>
                  To provide you with products and/or services by us, our affiliates or an
                  Authorised Third Party.
                </li>
              </ol>
              <br />
              <p>b. Customer Support and Communication</p>
              <ol type="i">
                <li>To establish and verify your identity and background.</li>
                <li>
                  To communicate with you regarding your account, transactions or any inquiries.
                </li>
                <li>To respond to your questions, feedback or support requests.</li>
                <li>To send important notices, updates or administrative messages.</li>
              </ol>
              <br />
              <p>c. Marketing, Promotions and Personalization</p>
              <ol type="i">
                <li>
                  To send you promotional materials, offers and updates on our products and/or
                  services.
                </li>
                <li>
                  To provide information on offerings from us, our affiliates or Authorised Third
                  Party.
                </li>
                <li>
                  To personalize content and marketing based on your preferences and usage patterns.
                </li>
                <li>To administer contests, campaigns and promotional events.</li>
              </ol>
              <br />
              <p>d. Research, Analytics and Service Enhancement</p>
              <ol type="i">
                <li>
                  To conduct market surveys, statistical analysis, trend monitoring and
                  user/customer profiling.
                </li>
                <li>
                  To support research and development of new features of our Sites, products and/or
                  services.
                </li>
                <li>To analyse usage patterns for service improvements and business planning.</li>
              </ol>
              <br />
              <p>e. Internal Operations and Security</p>
              <ol type="i">
                <li>To support internal audits, compliance reviews and operational planning.</li>
                <li>
                  For internal investigations and security purposes, including crime detection and
                  fraud prevention.
                </li>
                <li>For finance and credit control operations.</li>
              </ol>
              <br />
              <p>f. Legal and Regulatory Compliance</p>
              <ol type="i">
                <li>
                  To comply with applicable laws, regulations, guidelines or legal obligations
                  imposed by any authority.
                </li>
                <li>
                  To enforce our rights under the Terms of Use, General Terms and Conditions, and
                  relevant Campaign Terms and Conditions.
                </li>
              </ol>
              <br />
              <p>g. Other Legitimate Business Purposes</p>
              <ol type="i">
                <li>To carry out our other business activities.</li>
                <li>
                  For any other purposes reasonably necessary or directly related to the above.
                </li>
              </ol>
              <br />
              <p>
                If we intend on using any Personal Data in any manner or Purposes that are not
                consistent with this Privacy Notice, you will be informed of such anticipated use
                prior to or at the time at which the Personal Data is collected.
              </p>
              <br />
              <p>
                <strong>4. </strong>
                <strong>WHERE DO WE GET THIS INFORMATION ?</strong>
              </p>
              <p>We collect your Personal Data and other information from:</p>

              <p>
                a. your communication with us, when you submit an application form to become our
                user/customer, or when you contact us for any enquiries, including by calling our
                Customer Service.
              </p>
              <p>b. your use or subscription to our products and/or services.</p>
              <p>
                c. your participation in any of our surveys, promotions, competitions, contests or
                loyalty programs organised by us.
              </p>
              <p>
                d. your registration of interest and/or request for information of our products
                and/or services.
              </p>
              <p>e. your response to any marketing materials we send out.</p>
              <p>f. your visit to any of our offices, premises or retail centres.</p>
              <p>g. your browsing of our Sites.</p>
              <p>h. your interactions with us via live chats, WhatsApp, emails and our Sites.</p>
              <p>i. complaints that you lodge with us.</p>
              <p>j. feedback that you provide to us.</p>

              <br />
              <p>
                <strong>5. </strong>
                <strong>YOUR PERSONAL DATA DISCLOSURE</strong>
              </p>
              <p>
                We are not in the business of selling your Personal Data and other information that
                you have provided to us. We consider this information to be a vital part of our
                relationship with you. As such, we will not sell or rent your Personal Data, save
                and except as provided herein. There are, however, certain circumstances in which we
                may share your Personal Data with certain third parties without further notice to
                you, as set forth below:
              </p>
              <p>a. Business Transfer</p>
              <ul className="list-disc">
                <li>
                  As we develop our business, we might sell or buy businesses or assets. In the
                  event of a corporate sale, merger, reorganization, dissolution or similar event,
                  Personal Data may be part of the transferred assets.
                </li>
              </ul>
              <p>b. Affiliates</p>
              <ul className="list-disc">
                <li>
                  We may also share your Personal Data with our affiliates for Purposes consistent
                  with this Privacy Notice.
                </li>
              </ul>
              <p>c. Legal Requirements</p>
              <ul className="list-disc">
                <li>
                  To comply with any order of court or directive from authorities investigating any
                  alleged offence, misdeed and/or abuse, or to enforce any of the terms in the Terms
                  of Use, Privacy Notices or, where such action is necessary to protect and defend
                  our rights or property.
                </li>
              </ul>
              <p>d. Authorised Third Party</p>
              <ul className="list-disc">
                <li>
                  Where products and/or services from such Authorised Third Party are required, we
                  will share your Personal Data on a strictly confidential basis. An Authorised
                  Third Party will not be allowed to use your Personal Data disclosed to them except
                  for the limited purpose of providing the particular service.
                </li>
              </ul>
              <br />
              <p>
                <strong>6. </strong>
                <strong>PERSONAL DATA USE OUTSIDE OF MALAYSIA AND WHY ?</strong>
              </p>
              <p>
                We primarily process your Personal Data within Malaysia. However, it may be
                necessary to transfer your Personal Data and other information outside of Malaysia.
                This may occur if our affiliates or Authorised Third Parties are based outside
                Malaysia or if you use our products and/or services from countries outside of
                Malaysia.
              </p>
              <p>
                Your Personal Data may be transferred to any place outside of Malaysia that has:
              </p>
              <p>
                a. personal data protection laws which are substantially similar to the PDPA; or
              </p>
              <p>
                b. an adequate level of protection in relation to the processing of Personal Data,
                at least equivalent to the level of protection afforded by the PDPA.
              </p>

              <br />
              <p>
                <strong>7. COOKIES</strong>
              </p>
              <div className="custom-terms-remove-padding">
                <ol type="a">
                  <li>
                    When you use our Sites, your Device will automatically be issued with a cookie.
                    Cookies are text files that are placed in your Device&#x27;s hard drive to
                    identify your Device to our server. Generally, cookies themselves only record
                    those areas of the site that have been visited by the Device in question, and
                    the duration. Many websites and/or software applications do this whenever a
                    user/customer visits their site in order to track traffic flow.
                  </li>
                  <li>
                    Depending upon the type of Device you are using, you may set your Device to
                    accept all cookies, to notify you when a cookie is issued, or not to receive
                    cookies at any time. The last of these, of course, means that certain
                    personalised products and/or services cannot then be provided to you.
                  </li>
                  <li>
                    We use &quot;cookies&quot; to store and track information about you and your use
                    of our Sites.
                  </li>
                  <li>
                    Our cookies and information retrieved from our cookies are used in line with the
                    uses set out in this Privacy Notice and more specifically:
                    <ul className="list-disc">
                      <li>
                        to help save and retrieve passwords used on our Sites. This way, you will
                        not have to re-enter information upon every new visit to our Sites.
                      </li>
                      <li>
                        to track information such as the frequency and duration of your use of our
                        Sites, your clickstream as you go through our Sites, and help us determine
                        whether you came to our Sites from a particular Internet link or banner
                        advertisement.
                      </li>
                      <li>
                        to analyse the profile of visitors and users/customers to help us in
                        providing you with better products and/or services and to enhance our Sites.
                      </li>
                      <li>
                        to personalize the content, banners and promotions that you will see on our
                        Sites.
                      </li>
                    </ul>
                  </li>
                </ol>
              </div>

              <br />
              <p>
                You are always free to decline cookies if your Device permits, although in that
                case, you may not be able to use certain features of our Sites, and you may be
                required to re-enter your password more frequently during a session.
              </p>
              <br />
              <p>Third-Party Cookies</p>
              <p>
                We may use other third-party advertising companies to serve ads when you access our
                Sites. In the course of serving advertisements, our third-party advertisers may
                place or recognize a unique cookie in your Device. These companies may use
                information retrieved from their cookies to provide advertisements on our Sites and
                other products and/or services that may be of interest to you.
              </p>
              <br />
              <p>
                WE HAVE NO ACCESS TO OR CONTROL OVER THIRD-PARTY COOKIES AND THEY ARE NOT SUBJECT TO
                THIS PRIVACY NOTICE. PLEASE REVIEW THE PRIVACY NOTICE OF THESE THIRD-PARTY WEBSITES
                RESPECTIVELY FOR DETAILS. If you want to prevent one of these third-party companies
                from sending and reading cookies on your Device, you will need to visit each of
                their websites individually to request that you be removed from that system.
              </p>
              <br />
              <p>
                <strong>8. </strong>
                <strong>{`HAVE YOU ASKED YOUR PARENTS YET ? THIS IS ONLY IF YOU'RE UNDER 18`}</strong>
              </p>
              <p>
                {`  One or more of our Sites are not catered to users/customers under the age of 18, as
                our Sites may provide access to music or other content that contains explicit
                content, including the use of profane language and/or sexual references. If you are
                under 18, please obtain your parent/guardian's permission before using and/or
                accessing our Sites. Please do not provide us with your Personal Data unless you
                have obtained permission from your parent/guardian. Parental discretion is advised
                for all users/customers below 18. We encourage parents/guardians to monitor their
                children's internet usage and to help enforce this Privacy Notice by instructing
                their children never to provide Personal Data through our Sites without permission.
                If you have reason to believe that a child under the age of 18 has provided Personal
                Data to us through our Sites, please contact us and we will endeavour to delete that
                information from our database. Otherwise, all Personal Data provided by a
                user/customer shall be deemed to have been submitted by a user/customer above 18 or
                with the relevant permission from their parent/guardian.`}
              </p>
              <br />
              <p>
                <strong>9. SECURITY</strong>
              </p>
              <p>
                The internet is not a secure medium, and communications over the internet may be
                subject to third-party interception. We cannot accept responsibility for any
                unauthorised access or loss of personal information, save in accordance with the
                Terms of Use. We have implemented security policies, rules and technical measures to
                protect your Personal Data from unauthorised access, improper use or disclosure,
                unauthorised modification, unlawful destruction or accidental loss. All our
                employees and data processors, who have access to and are associated with the
                processing of Personal Data, are obliged to respect the confidentiality of your
                information.
              </p>
              <p>
                While we cannot guarantee that loss, misuse or alteration of data will not occur, we
                make reasonable efforts to prevent such unfortunate occurrences. Personal Data that
                we collect from you will be stored and backed up securely in an environmentally
                controlled location. Only authorized people with a user ID and password from our
                company have access to the information.
              </p>
              <br />
              <p>
                <strong>10. </strong>
                <strong>HOW LONG DO WE KEEP YOUR INFORMATION ?</strong>
              </p>
              <p>
                We may retain your Personal Data for as long as it is necessary to fulfil the
                Purposes for which it was collected or as required or permitted by applicable laws.
                We will cease to retain your Personal Data as soon as it is reasonable to assume
                that such retention no longer serves the Purposes for which the Personal Data was
                collected and is no longer necessary for legal or business purposes.
              </p>
              <br />
              <p>
                <strong>11. </strong>
                <strong>{`WHAT HAPPENS IF THERE'S A BREACH ?`}</strong>
              </p>
              <p>
                In compliance with the PDPA, we are committed to safeguarding your Personal Data. If
                we determine that there has been any breach, loss, misuse or unauthorized access to
                your Personal Data by a third party and such breach is likely to result in
                significant harm, we shall take the necessary steps to promptly notify you directly.
                We shall notify the relevant authorities as required under the PDPA.
              </p>
              <br />
              <p>
                <strong>12. </strong>
                <strong>{`IT'S YOUR DATA. WHAT ARE YOUR RIGHTS AND OBLIGATIONS ?`}</strong>
              </p>
              <p>a. Your rights</p>
              <ol type="i">
                <li>correct or update your Personal Data that we process and store.</li>
                <li>access your Personal Data, which we process and store.</li>
                <li>limit how we process your Personal Data in certain circumstances.</li>
                <li>
                  withdraw your consent for us to send any promotional and marketing materials about
                  our products and/or services by opting out or unsubscribing, unless you yourself
                  access the promotional and marketing materials made available through our Sites.
                </li>
                <li>
                  request for your Personal Data (excluding any commercially sensitive or
                  confidential information) to be transmitted to another data controller in
                  accordance with the PDPA.
                </li>
              </ol>
              <p>b. Your obligations</p>
              <ol type="i">
                <li>
                  provide accurate and updated information, including that of others you represent
                  or are responsible for and obtain consent from third parties if their data is
                  shared.
                </li>
                <li>
                  safeguard your own Personal Data. Please ensure that you log out after accessing
                  our Sites and/or close your browser window to prevent unauthorized access.
                </li>
                <li>must not, at any time, divulge your Personal Data to any third party.</li>
              </ol>
              <br />
              <p>
                <strong>13. </strong>
                <strong>WE WILL MAKE CHANGES AND UPDATES</strong>
              </p>
              <p>
                We reserve the right to update, revise or modify this Privacy Notice at any time and
                from time to time without prior notice. Any amendment to this Privacy Notice shall
                be published on our Sites or by other means as we deem fit. Please review this
                Privacy Notice periodically, and especially before you provide us with any of your
                Personal Data. Your continued use of our products and/or services access to our
                Sites after any changes, revisions or modifications to this Privacy Notice shall
                indicate your agreement with the terms of such revised notice. This Privacy Notice
                was last updated on the date indicated above.
              </p>
              <br />
              <p>
                <strong>14. </strong>
                <strong>GET IN TOUCH WITH US IF YOU WANT MORE INFORMATION</strong>
              </p>
              <p>
                You may, at any time, make inquiries regarding this Privacy Notice, your use of our
                products and/or services, your access to our Sites, or submit complaints. You may
                also request to exercise your rights, subject to a prescribed fee, where applicable,
                by submitting a written request from your registered email address to{' '}
                <a href="mailto:help.privacy@lumicko.com">help.privacy@lumicko.com</a>
              </p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
